<template>
    <div v-if="is_loaded">
        <BOverlay :show="is_load" rounded="sm">
            <div class="">
                <button class="btn btn-outline-primary mr-4" v-if="verificated == 1" v-on:click="un_confirm">
                    Повернути на перевірку
                </button>
                
                <button class="btn btn-primary mr-4" v-else v-on:click="confirm">
                   Затвердити
                </button>
                
                <button  type="button" class="btn btn-info send_letter " v-on:click="send_letter">
                   Написати листа
                </button>
            </div>
        </BOverlay>
        
        <send-email @send="onSend"></send-email>
        
    </div>
</template>

<script>
import {
    BOverlay,
} from 'bootstrap-vue-next';
import SendEmail from "./sendEmail.vue";
export default {
    name: "contragent_action",
    props : {
        id : {
            type : Number,
            default : 0,
        }
    },
    
    components : {
        SendEmail,
        BOverlay
    },
    
    data() {
        return {
            is_load : false,
            is_loaded : false,
            verificated : -1,
            
            showEmail : false,
        }
    },
    
    created() {
        this.getStatus();
    },
    
    methods : {
        async onSend(body) {
            console.log('email_body',body);
            await api.post('/tenders/sales/tenders/contragents/' + parseInt(this.id) + '/email',{
                body
            }).then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    IMC_CORE.snackbar('Відправлено');
                }
            }).catch(e => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        async getStatus() {
            this.is_load = true;
            this.is_loaded = false;
            
            this.verificated = -1;
            await api.get('/tenders/sales/tenders/contragents/' + parseInt(this.id) + '/state').then(({data}) => {
                this.is_load = false;
                this.is_loaded = true;
                if(data.status === "operation_success") {
                    this.verificated = data.data;
                  
                }
            }).catch(e => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        send_letter() {
            EventBus.$emit('show_email_send')
        },
        
        async confirm() {
           this.changeState('confirm');
        },
        
        async un_confirm() {
            this.changeState('un_confirm');
        },
        
        async changeState(new_state) {
            this.is_load = true;
            await api.patch('/tenders/sales/tenders/contragents/' + parseInt(this.id) + '/state',{
                'new_state' : new_state
            }).then(({data}) => {
                IMC_CORE.snackbar('Виконано');
                this.getStatus();
            }).catch(e => {
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
    }
}
</script>



<style scoped>

</style>